<mat-card appearance="outlined" *ngIf="registerOTP" class="mat-background-primary-light border-primary border"
  style="position: fixed; right: 5vh; bottom: 5vh; width: 350px;">
  <h3>
    Use your favourite authenticator mobile app as Weseth TOTP generator (e.g. Google Authenticator)
  </h3>
</mat-card>


<amplify-authenticator  [hideSignUp]="true" [loginMechanisms]="['email']">
  <ng-template amplifySlot="sign-in-header">
    <h2
      class="amplify-heading"
      style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl)"
    >
      Log into Weseth
  </h2 >
  </ng-template>



  <ng-template
    amplifySlot="authenticated"
    let-user="user"
    let-signOut="signOut"
  >

    <!-- Alternative in case user is logged -->
  <mat-card appearance="outlined" class="mat-elevation-z2 w-min-25-vw">
    <mat-card-content class="text-center">

      <h2>Logged in!</h2>
      <mat-spinner class="mt-10 center" color="primary" mode="indeterminate"></mat-spinner>
      <h3 class="mt-2_5">Taking you there...</h3>

    </mat-card-content>
  </mat-card>
    <!-- ********************************* -->

</ng-template>
</amplify-authenticator>
